import React from "react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-white/8 bg-black">
      <div className="container-x px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center">
              <img
                src="/assets/protos-logo.png"
                alt="PROTOS"
                className="h-12 lg:h-16 w-auto"
                style={{ filter: "drop-shadow(0 0 24px rgba(31,179,255,0.4))" }}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.nextElementSibling.style.display = "inline-flex";
                }}
              />
              <span
                className="font-display text-5xl lg:text-6xl uppercase tracking-wider"
                style={{ display: "none", letterSpacing: "0.04em" }}
              >
                <span className="text-white">PRO</span>
                <span style={{ color: "var(--blue-bright)" }}>TOS</span>
              </span>
            </div>
            <p className="mt-6 text-white/55 max-w-md text-sm lg:text-base leading-relaxed">
              Performance chew. Focus, calm, control in 90 seconds. Engineered in small batches
              for people who don't get a second take.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-white/40 mb-5">Product</div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><a href="#beta" data-magnet>Protos 100</a></li>
              <li><a href="#idea" data-magnet>The Idea</a></li>
              <li><a href="#benefits" data-magnet>Effect</a></li>
              <li><a href="#participate" data-magnet>Participate</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-white/40 mb-5">Follow</div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><a href="https://www.instagram.com/letsgoprotos/" target="_blank" rel="noopener noreferrer" data-magnet>Instagram ↗</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/35">
            © {new Date().getFullYear()} Protos · All rights reserved
          </span>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-5">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/35">
              Made for the moment.
            </span>
            {/* Designed-by credit — kept in DOM for SEO + accessibility, hidden visually */}
            <a
              href="https://revurge.com"
              target="_blank"
              rel="noopener noreferrer author"
              data-testid="footer-revurge"
              className="sr-only"
              aria-label="Designed and built by Revurge — revurge.com"
            >
              Designed and built by Revurge — revurge.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
